import { render, staticRenderFns } from "./ShowNegative.vue?vue&type=template&id=3136823c&scoped=true"
import script from "./ShowNegative.vue?vue&type=script&lang=js"
export * from "./ShowNegative.vue?vue&type=script&lang=js"
import style0 from "./ShowNegative.vue?vue&type=style&index=0&id=3136823c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3136823c",
  null
  
)

export default component.exports